/**
 * Send `body` as a JSON request. The Content-Type header and the serialisation
 * are one decision, not two, and every JSON write in the app made it separately.
 *
 * Returns the raw Response. The callers genuinely differ in how they read a
 * failure - a thrown error, a status chip, a specific error code off the body,
 * or nothing at all - so only the request itself belongs here.
 */
export function sendJson(
  method: "POST" | "PUT" | "PATCH",
  url: string,
  body: unknown,
  /** The streaming agent calls abort in-flight requests; nothing else needs this. */
  options?: { signal?: AbortSignal | null },
): Promise<Response> {
  return fetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    // Spread rather than always setting `signal: undefined`: the tests that assert
    // the exact request init should keep seeing the init they always saw.
    ...(options?.signal ? { signal: options.signal } : {}),
  });
}

export function postJson(
  url: string,
  body: unknown,
  options?: { signal?: AbortSignal | null },
): Promise<Response> {
  return sendJson("POST", url, body, options);
}

export function putJson(url: string, body: unknown): Promise<Response> {
  return sendJson("PUT", url, body);
}
